import { render, staticRenderFns } from "./Suite.vue?vue&type=template&id=6091c1be&scoped=true"
import script from "./Suite.vue?vue&type=script&lang=js"
export * from "./Suite.vue?vue&type=script&lang=js"
import style0 from "./Suite.vue?vue&type=style&index=0&id=6091c1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6091c1be",
  null
  
)

export default component.exports